/**
 * Rule-based carousels for the landing page.
 *
 * Unlike the manually curated ("themed") collections - which are lists of
 * listing IDs entered by hand in the Sharetribe recommendations page - these
 * carousels are populated automatically by a listings query. This file is the
 * single place to declare them: to add another rule-based carousel, append an
 * entry to RULE_BASED_COLLECTIONS.
 *
 * Rules (kept identical to the manually curated carousels):
 * - A carousel only appears if at least MIN_THEMED_LISTINGS matching listings
 *   are available (see fetchRuleBasedCollections in LandingPage.duck.js).
 *
 * Performance:
 * - Each entry costs exactly one `sdk.listings.query`. These run in parallel,
 *   client-side, after the initial page render (same as the featured/themed
 *   fetches), so they never block the front page load.
 * - Keep queries cheap: prefer a single indexed query per carousel via
 *   `queryParams`, and use `matches` only to refine what the query already
 *   returned - never to trigger extra requests.
 *
 * Each entry:
 * - sectionId:   Unique id used as the carousel's DOM/section id. Must start
 *                with the 'rule-' prefix: the carousel styling in
 *                SectionFeaturedListings.module.css targets sections by id
 *                (`[id^="active-"]` for curated, `[id^="rule-"]` for these), so
 *                an id without the prefix renders unstyled. Must not collide
 *                with the manually curated 'active-*' section names.
 * - title:       Heading shown above the carousel.
 * - queryParams: Extra params merged into `sdk.listings.query`. `keywords`
 *                uses Sharetribe's full-text index (title + description) as a
 *                cheap server-side pre-filter.
 * - matches:     Optional client-side predicate `(listing) => boolean` applied
 *                to the query results, for precision the server-side query
 *                can't express on its own.
 */
export const RULE_BASED_COLLECTIONS = [
  {
    sectionId: 'rule-blind-date',
    title: 'Blind date with a book',
    // `keywords` narrows the result set server-side to listings mentioning
    // these terms in their title or description.
    queryParams: { keywords: 'blind date' },
    // Sharetribe keyword search also matches the description, so refine to
    // listings whose *title* actually contains the phrase (any case).
    matches: listing =>
      (listing?.attributes?.title || '').toLowerCase().includes('blind date'),
  },
];
